import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { DuckBadge } from "@/components/DuckMascot";
import { useSolidHeader } from "@/components/HeaderThemeContext";

export default function NotFound() {
  useSolidHeader();
  return (
    <div className="pt-[72px] min-h-[80vh] flex items-center" data-testid="not-found-page">
      <Seo title="Page not found" description="That page flew off somewhere." path="" noindex />
      <div className="max-w-xl mx-auto px-4 text-center">
        <div className="flex justify-center mb-6">
          <DuckBadge size={96} />
        </div>
        <p className="text-terracotta uppercase tracking-[0.25em] text-sm font-semibold">404</p>
        <h1 className="mt-3 font-serif text-4xl sm:text-5xl font-black text-forest-950">This page bugged out.</h1>
        <p className="mt-4 text-lg text-forest-950/70">
          We couldn't find what you were looking for. Let's get you back to something useful.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="px-7 py-3.5 rounded-full bg-forest-950 text-cream font-semibold hover:bg-forest transition-all" data-testid="notfound-home-btn">
            Back home
          </Link>
          <Link to="/pests" className="px-7 py-3.5 rounded-full border border-forest/20 text-forest-950 font-semibold hover:bg-pill/60 transition-all" data-testid="notfound-pests-btn">
            Browse pests
          </Link>
        </div>
      </div>
    </div>
  );
}
